import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { tokensToCss } from '@going-once/tokens';
import { App } from './App';

/**
 * The token contract is injected as CSS custom properties at boot, from the same TS
 * source the components import (D24.5: one token layer, two renderers — the mobile app
 * will consume the same module without any CSS).
 */
const style = document.createElement('style');
style.textContent = `${tokensToCss()}
* { box-sizing: border-box; }
body { margin: 0; background: var(--go-color-bg-base); font-family: var(--go-family-base); color: var(--go-color-fg-default); }
/* Honor the OS preference, but dark is the default the brief asks for: dark chrome
   around bright video is easier over a two-hour show. */
@media (prefers-color-scheme: light) { :root { color-scheme: light; } }
`;
if (window.matchMedia('(prefers-color-scheme: light)').matches) {
  document.documentElement.dataset.theme = 'light';
}
document.head.append(style);

const root = document.getElementById('root');
if (!root) throw new Error('no #root element');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
